import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@heidi/design-system/dialog';
import { useIntl } from 'react-intl';

import type { PermissionMode, PermissionName, PermissionStatusMap } from '../types';
import {
  desktopPermissionGateDescription,
  desktopPermissionGateTitle,
} from './desktop-permission-gate-copy';
import { DesktopPermissionPanel } from './desktop-permission-panel';

interface DesktopPermissionModalProps {
  open: boolean;
  mode: PermissionMode;
  missing: readonly PermissionName[];
  statuses: PermissionStatusMap;
  onOpenChange: (open: boolean) => void;
  onRequestPermission: (permission: PermissionName) => void;
}

export function DesktopPermissionModal({
  open,
  mode,
  missing,
  statuses,
  onOpenChange,
  onRequestPermission,
}: DesktopPermissionModalProps) {
  const intl = useIntl();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="desktop-permission-modal"
        className="max-w-md border-0 bg-transparent p-0 shadow-none"
      >
        <DialogHeader className="sr-only">
          <DialogTitle>{desktopPermissionGateTitle(intl, mode)}</DialogTitle>
          <DialogDescription>
            {desktopPermissionGateDescription(intl, mode)}
          </DialogDescription>
        </DialogHeader>
        <DesktopPermissionPanel
          mode={mode}
          missing={missing}
          statuses={statuses}
          onRequestPermission={onRequestPermission}
        />
      </DialogContent>
    </Dialog>
  );
}
